import { useState } from 'react';

export function useFilterAnchor(filterId: string) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const popoverId = open ? filterId : undefined;
  return { anchorEl, handleOpen, handleClose, open, popoverId };
}
